export default {
  dbb_filter_all: 'All',
  dbb_filter_all_info: 'Display data results based on de-duplicated users for all {name}',
  dbb_country_all: 'All represents the total aggregated data for all the respective countries.',
  dbb_filter_pcu_title: 'PCU Range',
  dbb_filter_download_title: 'Download Range',
  dbb_filter_revenue_title: 'Revenue Range',
  dbb_filter_pcu_left_placeholder: 'Minimum',
  dbb_filter_pcu_right_placeholder: 'Maximum',
  dbb_filter_revenue_left_placeholder: 'Minimum',
  dbb_filter_revenue_right_placeholder: 'Maximum',
  dbb_filter_download_left_placeholder: 'Minimum',
  dbb_filter_download_right_placeholder: 'Maximum',
  dbb_filter_download_by_percentile: 'Percentile',
  dbb_filter_download_number_og_top10: 'Top Games',
  dbb_filter_download_customized_range: 'Customized Range',
  dbb_filter_download_by_percentile_top: 'Percentile - Top',
  dbb_filter_download_by_percentile_of_games: '%',
  dbb_filter_download_by_top_game: 'Top Games - Top',
  dbb_filter_download_by_top_game_of_games: ' ',

  dbb_filter_input_error: 'Input error, please enter an integer without special characters',
  dbb_filter_input_less_min: 'The maximum value cannot be less than the minimum value',
  dbb_filter_input_more_max: 'The minimum value cannot be greater than the maximum value',
  dbb_filter_input_percent_max: 'Input error, please enter an integer within 100',

  dbb_filter_pcu_tooltip: 'The historical peak number of concurrent users on Steam',
  dbb_filter_revenue_tooltip: "Total Steam revenue for the first year after the game's official release, according to VG Insights datasource",
  dbb_filter_download_tooltip: "The number of downloads in the first year after the game's official release",
  dbb_filter_release_time_tooltip: "Select a period to select games released during that period.",
};